/* @flow */

import React from 'react';
import styled from 'styled-components';
// $FlowFixMe
import LinesEllipsis from 'react-lines-ellipsis';
import withI18n from '../../../utils/withI18n';
import { getLabel } from '../../../utils/i18n';
import FlexBox from '../../FlexBox';
import { Link } from '../../../routes';

import { gwGet } from '../../../actions/actionsFactory/gwRequest';
import API_PATH from '../../../actions/actionsFactory/apiPath';
import { formatDate } from '../../../utils/datetime';

const WrapperBox = styled(FlexBox)`
  width: 100%;
  height: auto;
  overflow: hidden;
  padding: 90px 0 100px 0;
  font-family: ${({ theme }) => theme.fontIBMLight};
  background: #fff;
`;
const Content = styled.div`
  width: 100%;
  max-width: 1260px;
  margin: 0 auto;
`;
const Title = styled.div`
  font-size: 54px;
  color: #212833;
  font-weight:200;
  padding-bottom: 25px;
`;
const Description = styled.div`
  font-size: 16px;
  color: #48515d;
  font-family: ${({ theme }) => theme.fontIBMMedium};
  > p {
    margin-bottom: 25px;
  }
  > a {
    color: #212833;
    font-size: 16px;
    font-family: ${({ theme }) => theme.fontIBMMedium};
  }
`;

const List = styled(FlexBox)`
  width: 100%;
  margin-top: 100px;
`;
const Item = styled.div`
  width: 388px;
  height: auto;
  overflow: hidden;
  > a {
    color: #0b0e11;
  }
`;
const ItemImg = styled.div`
  > img {
    width: 100%;
    height: 218px;
  }
`;
const ItemTitle = styled.h2`
  margin: 16px 0 10px 0;
  font-size: 24px;
  color: #0b0e11;
  > div.LinesEllipsis {
    height: 72px;
    font-family: ${({ theme }) => theme.fontIBMMedium};
  }
`;
const ItemDes = styled.p`
  line-height: 22px;
  font-size: 14px;
  color: #848e9c;
  margin-bottom: 28px;
  > div.LinesEllipsis {
    height: 44px;
    font-family: ${({ theme }) => theme.fontIBMRegular};
  }
`;
const Author = styled.div`
  height: auto;
  overflow: hidden;
  > img {
    width: 36px;
    height: 36px;
    border-radius: 100%;
    display: block;
    float: left;
    margin-top: 2px;
  }
  > div {
    margin-left: 52px;
    > h3 {
      font-size: 16px;
      color: #212833;
      margin: 0;
      font-family: ${({ theme }) => theme.fontIBMRegular};
    }
    > p {
      font-size: 14px;
      color: rgba(72, 81, 93, 0.8);
      font-family: ${({ theme }) => theme.fontIBMRegular};
      margin: 0;
      line-height: 100%;
    }
  }
`;

type Props = {
  i18n: Object,
  locale: string,
  router: Object,
};

type States = {
  blogList: Array<Object>,
};

export default
@withI18n
class Blog extends React.Component<Props, States> {
  static defaultProps = {
    i18n: {},
    locale: 'en',
    router: {},
  };

  state = {
    blogList: [],
  };

  retryCount: number = 0

  componentDidMount() {
    this._getBlogList(this.props.locale);
  }

  componentWillReceiveProps(nextProps: Object) {
    if (this.props.locale !== nextProps.locale) {
      this.retryCount = 0;
      this._getBlogList(nextProps.locale);
    }
  }

  _getBlogList = async (locale: string) => {
    if (this.retryCount++ > 1) return;
    try {
      const result = await gwGet(`${API_PATH.BLOG_LIST_API}?lang=${locale}&pageIndex=1&pageSize=3`);
      const { data = [], success } = result;
      if (success && data.length > 0) {
        data.forEach(item => {
          try {
            const banner = JSON.parse(item.banner);
            item.imgUrl = banner.bannerUrl;
          } catch (error) {
            // noop
          }
        });
        this.setState({ blogList: data });
      } else {
        throw new Error();
      }
    } catch (error) {
      // retry to fetch with en locale
      this._getBlogList('en');
    }
  };

  render() {
    const { i18n, locale } = this.props;
    const { blogList } = this.state;

    if (blogList.length === 0) return null;

    return (
      <WrapperBox direction="column">
        <Content>
          <Title>{getLabel('exchange-blog-binanceBlog', i18n)}</Title>
          <Description>
            <p>{getLabel('exchange-blog-aboutBinanceEcosystem', i18n)}</p>
            <a id="blog-a-BlogViewAll" href="blog" target="_blank">
              {getLabel('exchange-common-viewAll', i18n)} {'>>'}
            </a>
          </Description>
          <List justify="space-between">
            {
              blogList.map(item => (
                <Item key={item.articleId}>
                  <Link route={`/${locale}/blog/${item.idStr}/${item.title}`} prefetch={true}>
                    <a target="_blank" id={`blog-a-${item.articleId}`}>
                      <ItemImg>
                        <img src={item.imgUrl} alt={item.title} />
                      </ItemImg>
                      <ItemTitle>
                        <LinesEllipsis
                          text={item.title}
                          maxLine="2"
                          ellipsis="..."
                          trimRight={true}
                          basedOn="letters"
                        />
                      </ItemTitle>
                      <ItemDes>
                        <LinesEllipsis
                          text={item.brief}
                          maxLine="2"
                          ellipsis="..."
                          trimRight={true}
                          basedOn="letters"
                        />
                      </ItemDes>
                      <Author>
                        <img src={require('./testImg/press-blog.svg')} alt={item.title} />
                        <div>
                          <h3>Binance</h3>
                          <p>
                            {locale !== 'cn' &&
                              formatDate(item.postTime || item.createTime, 'y', locale)}
                            {locale !== 'cn' && ', '}
                            {locale !== 'cn' &&
                              formatDate(item.postTime || item.createTime, 'm', locale)}
                            {locale === 'cn' &&
                              formatDate(item.postTime || item.createTime, 'y', locale)}
                            {locale === 'cn' && '-'}
                            {locale === 'cn' &&
                              formatDate(item.postTime || item.createTime, 'm', locale)}
                          </p>
                        </div>
                      </Author>
                    </a>
                  </Link>
                </Item>
              ))}
          </List>
        </Content>
      </WrapperBox>
    );
  }
}
